module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQElEQVQ4T6WToUsFQRDGv7l/wGoxqxgMJotNzQYFwWK4++7AoMFi8RlsgtHbCyoIBgU1v2q2CKI2g0UQ0WC9kT1uz/XeHdzDLQuz8/125ttZwT+XNOmNMbsApgDMikigqncAHvM8P0qS5MXX/AEYYyYA3AAYbynsO8/zjSRJTt15BTDGjAD47NJREARzYRje2lwfcAxgHUCvhLjdMf34h62S5HsByLJsSVWvnJDkXulDJarHVPUgjuPtAlBLtqGeJ0AD0Ob0SS46wAWA5Vr/BaTlAht+IznqAGcA1oYEvJIcc4BNAIceoEsLlyRXCkCapvMi0h/GROdT9YxZlp2r6mrHZ3wmaYfudw5Ks7TLIAGYJPk0ACghOwD2W0AnALZIfg2Msi8wxiyIyIyqTgMIADyIyH0URdd1cONv7NhGkfYDhXaVEe62rL0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 3